import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader, IonItem,
    IonLabel,
    IonPage,
    IonText,
    IonTitle,
    IonToolbar
} from '@ionic/react';
import './Tab2.css';
import React from "react";
import AudioHandler from "../components/AudioHandler";
import {iOSVersion, isIOS, WebKitVersion} from "../App";

const Tab2: React.FC = () =>  {

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Tab 2</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle>Tab 2</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <AudioHandler highlights={[
                    // {
                    //     visible: true,
                    //     type: 'rect',
                    //     xref: 'x',
                    //     yref: 'y',
                    //     x0: 3800,
                    //     x1: 4200,
                    //     y0: -100,
                    //     y1: 0,
                    //     layer: 'below',
                    //     fillcolor: '#40A7FF',
                    //     opacity: 0.3,
                    //     line: {
                    //         width: 0
                    //     }
                    // }
                ]}/>
            </IonContent>
            <IonContent>
                {isIOS ? <IonItem><IonText>Browser Info</IonText></IonItem> : <IonItem></IonItem> }
                {isIOS ? <IonItem><IonText>WebKit Version: {WebKitVersion()}</IonText></IonItem> : <IonItem></IonItem>}
                {isIOS ? <IonItem><IonText>iOS Version: {iOSVersion()}</IonText></IonItem> : <IonItem></IonItem>}
            </IonContent>
        </IonPage>
    );
};

export default Tab2;
